// Build a b-form-select options array from a TypeScript numeric enum. The enum
// mirror has reverse mappings (numeric -> name AND name -> numeric), so we filter
// to the name keys only and emit { value: numeric, text: name } pairs.
//
// Use case: every UI that surfaces an enum mirrored from a C# enum (DeliveryCode,
// OrderStatus, etc.) was duplicating the same `Object.keys(...).filter(isNaN)` dance.
export interface EnumOption<T extends number | null = number> {
    value: T;
    text: string;
}

export function enumToOptions<E extends Record<string, string | number>>(
    enumObj: E,
    options: { includeNone?: boolean; noneText?: string } = {},
): Array<EnumOption<number | null>> {
    const opts: Array<EnumOption<number | null>> = options.includeNone
        ? [{ value: null, text: options.noneText ?? '(None)' }]
        : [];

    for (const key of Object.keys(enumObj)) {
        if (!isNaN(Number(key))) continue; // skip reverse mappings (numeric -> name)
        opts.push({ value: enumObj[key] as number, text: key });
    }
    return opts;
}
